import { CreateOrganization } from '@clerk/react';
import { AuthLayout } from './AuthLayout';

export function OrgSetup() {
  return (
    <AuthLayout>
      <div className="text-center -mt-2 mb-1">
        <h1 className="font-display font-bold text-lg text-ink">Un paso más</h1>
        <p className="text-ink-muted text-sm mt-0.5">
          Crea tu iglesia u organización para comenzar
        </p>
      </div>
      <CreateOrganization afterCreateOrganizationUrl="/" />
    </AuthLayout>
  );
}
